// Globals
import { Switch } from 'antd';
import { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { PromotionStatus } from '@/models/promotion.model';

// Components
import { PopConfirm } from '@/ui';

// Helpers
import { useUpdateCoupon } from '../../hooks';
import { UpdateCouponDTO } from '../../dtos';

type TCouponActivityProps = {
  isActive: boolean;
  couponId: string;
};

const CouponActivitySwitch: FC<TCouponActivityProps> = ({ isActive, couponId }) => {
  const { t } = useTranslation(['common']);
  const { isLoading, updateCoupon } = useUpdateCoupon();

  const handleChange = async () => {
    try {
      const dto = new UpdateCouponDTO({
        couponId,
        status: isActive ? PromotionStatus.INACTIVE : PromotionStatus.ACTIVE,
      });
      await updateCoupon(dto);
    } catch (error) {
      console.error(error);
    }
  };

  const handleStopPropagation = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <div onClick={handleStopPropagation} onKeyDown={handleStopPropagation}>
      <PopConfirm
        title={t(isActive ? 'modal_coupon_disable_title' : 'modal_coupon_enable_title')}
        onConfirm={handleChange}
      >
        <Switch
          checked={isActive}
          checkedChildren={t('modal_coupon_active_title')}
          unCheckedChildren={t('modal_coupon_disabled_title')}
          loading={isLoading}
        />
      </PopConfirm>
    </div>
  );
};

export default CouponActivitySwitch;
